/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { TipologiaComune } from './tipologiaComune';

export interface ComuneViewImpl { 
    id?: string;
    annoDiRiferimento?: string;
    nome?: string;
    slug?: string;
    gestioneManuale?: boolean;
    tipologia?: TipologiaComune;
}